import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getTrip = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeTrip.stops;
export const getLoading = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeTrip.loading;
